import { useState, useRef } from 'react';
import PdfViewerReactLite from 'pdf-viewer-react-lite';


function App() {

  const [pdfViewerUrl, setPdfViewerUrl] = useState("");
  const fileInputRef = useRef(null);

  const handleFileSelect = (event) => {
    const file = event.target.files?.[0];
    if (file && file.type === 'application/pdf') {
      const url = URL.createObjectURL(file);
      setPdfViewerUrl(url);
    } else {
      alert('Please select a valid PDF file.');
    }
    // Reset file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleSelectFile = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="flex flex-col items-center pt-8 pb-2">
        <h1 className="text-5xl font-extrabold text-blue-800 drop-shadow mb-2">
          Welcome to PDF Viewer
        </h1>
        <p className="text-lg text-gray-600 mb-2 text-center">
          Seamlessly view PDF documents in your application. Use the viewer to upload your own PDF files!
        </p>
        <div className="flex gap-4">
          <button
            onClick={() => setPdfViewerUrl("https://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf")}
            className="bg-blue-600 cursor-pointer text-white px-6 py-3 rounded-xl shadow hover:bg-blue-700 focus:ring-2 focus:ring-blue-400 focus:outline-none transition-all font-semibold text-lg"
          >
            Open Sample PDF
          </button>
          <button
            onClick={handleSelectFile}
            className="bg-green-600 cursor-pointer text-white px-6 py-3 rounded-xl shadow hover:bg-green-700 focus:ring-2 focus:ring-green-400 focus:outline-none transition-all font-semibold text-lg"
          >
            Select File from Local
          </button>
        </div>
        <input
          ref={fileInputRef}
          type="file"
          accept=".pdf,application/pdf"
          onChange={handleFileSelect}
          className="hidden"
          aria-label="Upload PDF file"
        />
      </div>
      <div className="flex justify-center mt-8">
        <div className="w-full h-screen max-w-4xl min-h-[500px] rounded-2xl shadow-xl border-2 border-blue-200 bg-gradient-to-br from-blue-50 to-white p-4 relative">
          <PdfViewerReactLite
            pdfUrl={pdfViewerUrl}
            onClose={() => { setPdfViewerUrl("") }}
            className="rounded-xl"
          />
        </div>
      </div>

      {/* Footer with application information */}
      <footer className="mt-12 pb-8 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="border-t border-gray-200 pt-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
              About PDF Viewer React Lite
            </h2>
            <p className="text-gray-600 text-center mb-6 max-w-2xl mx-auto">
              A simple, lightweight, high-performance, feature-rich PDF viewer component for React.js and Next.js applications.
              Built with modern web technologies to provide a seamless document viewing experience.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
              <div className="text-center">
                <div className="text-3xl mb-2">📄</div>
                <h3 className="font-semibold text-gray-800 mb-2">PDF Rendering</h3>
                <p className="text-sm text-gray-600">View PDFs from URLs or local files with high-quality rendering</p>
              </div>
              <div className="text-center">
                <div className="text-3xl mb-2">🔍</div>
                <h3 className="font-semibold text-gray-800 mb-2">Zoom Controls</h3>
                <p className="text-sm text-gray-600">Zoom in/out with customizable scale limits and smooth transitions</p>
              </div>
              <div className="text-center">
                <div className="text-3xl mb-2">⌨️</div>
                <h3 className="font-semibold text-gray-800 mb-2">Keyboard Shortcuts</h3>
                <p className="text-sm text-gray-600">Navigate and control the viewer with intuitive keyboard shortcuts</p>
              </div>
            </div>

            <div className="mt-8 text-center text-sm text-gray-500">
              <p>Built with React, TypeScript, and PDF.js</p>
              <p className="mt-2">© 2025 PDF Viewer React Lite. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;

